import { Component, h, Prop } from '@stencil/core';

@Component({
    tag: 'kdx-section-title',
    styleUrl: 'kdx-section-title.scss'
})
export class KdxSectionTitle {

    @Prop() orientation: string = "center-aligned";  // left-aligned or center-aligned

    render() {
        return (
            <div class={`kdx-section-title ${this.orientation}`}>
                <slot />
            </div>
        );
    }
}
